import { render, staticRenderFns } from "./AutoSuggestionEditor.vue?vue&type=template&id=37e17931&scoped=true"
import script from "./AutoSuggestionEditor.vue?vue&type=script&lang=js"
export * from "./AutoSuggestionEditor.vue?vue&type=script&lang=js"
import style0 from "./AutoSuggestionEditor.vue?vue&type=style&index=0&id=37e17931&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37e17931",
  null
  
)

export default component.exports